import { IconButtonProps } from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import RowNumberSelect from "@saleor/components/RowNumberSelect";
import { ListSettings } from "@saleor/types";
import React from "react";

import DropOffTablePaginationActions from "./DropOffTablePaginationActions";

const useStyles = makeStyles(
  theme => ({
    spacer: {
      flex: "initial",
      left: theme.spacing(3.25),
      position: "sticky"
    },
    toolbar: {
      height: 56,
      justifyContent: "space-between",
      minHeight: 56,
      paddingLeft: 2,
      paddingRight: 2
    }
  }),
  { name: "DropOffTablePagination" }
);

interface DropOffTablePaginationProps {
  backIconButtonProps?: Partial<IconButtonProps>;
  settings?: ListSettings;
  totalCount?: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  nextIconButtonProps?: Partial<IconButtonProps>;
  choices?: any;
  onNextPage(event);
  onPreviousPage(event);
  onUpdateListSettings?(key: keyof ListSettings, value: any): void;
}

const DropOffTablePagination: React.FC<DropOffTablePaginationProps> = props => {
  const {
    backIconButtonProps,
    choices,
    settings,
    totalCount,
    hasNextPage,
    hasPreviousPage,
    nextIconButtonProps,
    onNextPage,
    onPreviousPage,
    onUpdateListSettings
  } = props;
  const classes = useStyles(props);

  return (
    <Toolbar className={classes.toolbar}>
      <div className={classes.spacer}>
        {!!settings?.rowNumber && (
          <RowNumberSelect
            choices={choices || [10, 20, 30, 50, 100]}
            settings={settings}
            onChange={onUpdateListSettings}
          />
        )}
      </div>
      <DropOffTablePaginationActions
        totalCount={totalCount}
        backIconButtonProps={backIconButtonProps}
        hasNextPage={hasNextPage}
        hasPreviousPage={hasPreviousPage}
        nextIconButtonProps={nextIconButtonProps}
        onNextPage={onNextPage}
        onPreviousPage={onPreviousPage}
      />
    </Toolbar>
  );
};

DropOffTablePagination.displayName = "DropOffTablePagination";
export default DropOffTablePagination;
